import React, { useState, createContext, useContext } from 'react';
export type Lang = 'en' | 'hr';
const translations = {
  en: {
    // Hero
    heroOverline: 'Portfolio',
    heroTitle1: 'Developing digital',
    heroTitle2: 'products with craft.',
    heroSubtitle: 'Developer focused on beautiful, performant web experiences with meticulous attention to detail.',
    heroStat1Value: '15+',
    heroStat1Label: 'Projects Delivered in 2025',
    heroStat2Value: '6+',
    heroStat2Label: 'Years Experience',
    heroStat3Value: '8',
    heroStat3Label: 'Services Offered',
    heroScroll: 'Scroll to explore',
    // Marquee
    marqueeText: 'Design · Develop · Deploy · ',
    // Projects
    projectsOverline: 'Selected Work',
    projectsTitle: 'Recent projects',
    projectsTotal: 'total recent projects',
    projectsViewAll: 'View All',
    projectsProjects: 'Projects',
    projectsAllProjects: 'All Projects',
    // Project Descriptions
    projDescSocialamour: 'Premium social media agency showcase powering the core team for Hollywood A-listers like Selma Hayek, Luke Evans, and world-class global brands – delivering razor-sharp, modern service presentation.',
    projDescHmd: "Bespoke London-based architect's showcase featuring bold visual identity, smooth micro-interactions, and impeccable minimal design crafted for creative excellence.",
    projDescAbc: 'Renowned Croatian interior design firm specializing in premium kitchens and retail spaces, featuring sophisticated eCommerce platform with curated product catalog and visual-first browsing experience for their established luxury clientele.',
    projDescAnic: 'Corporate masterpiece with interactive map featuring 400+ geo-pinned locations, advanced search by viewport, custom pin data visualization, and seamless company overview integration.',
    projDescWarans: 'Elegant fine art gallery with secure purchasing and custom My Account dashboard displaying real-time artwork value appreciation graphs – fully bespoke WooCommerce development.',
    projDescPatela: 'Medical clinic website with professional aesthetics and patient-focused UX.',
    projDescGromela: 'Business center website with clean layout and comprehensive service overview.',
    projDescTerranook: 'Nature-inspired brand site with warm aesthetics and immersive storytelling.',
    projDescMagicpulse: 'Health supplement e-commerce with engaging product showcases and smooth checkout.',
    projDescRoyal: 'Premium beauty e-commerce with fluid animations and seamless shopping experience.',
    projDescWalllab: 'Wall decoration shop with visual product configurator and modern interface.',
    projDescJoka: "Fashion eCommerce store following the owner's unique retro design vision – stylish clothing showcase with vintage-modern fusion and seamless shopping experience.",
    projDescZalagaonice: 'Pawn shop marketplace with search-driven browsing and detailed listings.',
    projDescSwanky: "Zagreb's most popular modern hostel with a well-known bar and restaurant – booking platform featuring vibrant design, real-time availability, and the city's best social atmosphere.",
    projDescZlatnirat: 'Zlatni Rat Bay premium hotel with streamlined reservation flow and elegant guest experience presentation.',
    projDescValmik: 'Premium luxury car rental platform with real-time fleet availability, high-end vehicle showcase, and seamless booking process.',
    projDescFeluro: 'Boat rental service with visual fleet showcase and easy reservation system.',
    projDescSpeedboat: 'Speedboat tours and rentals with adventure-focused design and quick booking.',
    // Categories
    catAll: 'All',
    catBrandIdentity: 'Brand Identity',
    catEcommerce: 'eCommerce',
    catBooking: 'Booking',
    catRentCar: 'Rent a Car',
    catRentBoat: 'Rent a Boat',
    catCustom: 'Custom-Special',
    // About
    aboutOverline: 'About',
    aboutTitle: 'Smooth digital operator.',
    aboutP1: 'I believe the best digital products come from obsessive attention to detail — in both how they look and how they work. Every project is an opportunity to create something that feels considered and intentional.',
    aboutP2: 'With over six years of experience shipping products, I bring a deep understanding of modern web technologies and a relentless focus on craft.',
    aboutP3: "I've worked as a team lead in an agency environment, and I also take on solo projects where I handle everything from initial design to final development and deployment.",
    servicesOverline: 'Services',
    svcWebDev: 'Web Development',
    svcEcommerce: 'eCommerce Solutions',
    svcAI: 'AI Integrations',
    svcMonthly: 'Monthly Website Management',
    svcDomain: 'Domain & Hosting Management',
    svcEmail: 'Email Setup',
    svcPerformance: 'Performance Optimization',
    svcSEO: 'SEO',
    // Education & Experience
    educationLabel: 'Education',
    experienceLabel: 'Experience',
    educationDegree: "Bachelor's Degree",
    expRole1: 'Developer Team Lead',
    expType1: 'Past Experience',
    expDesc1: 'Directs web projects in a marketing agency, delivering custom solutions and full infrastructure management while mentoring design and junior teams.',
    expRole2: 'Front End Developer',
    expType2: 'Past Experience',
    expDesc2: 'Building performant, pixel-perfect interfaces across a range of client projects.',
    expRole3: 'Founder — Personal Projects',
    expType3: 'Ongoing',
    expDesc3: 'Conceiving, building, and growing products from scratch — including Crobot.ai.',
    // Crobot
    crobotOverline: 'Personal Project · Founder',
    crobotTitle: 'Personal Project - Crobot.ai',
    crobotDesc: "A personal passion project — Croatia's first AI chatbot platform, built entirely from scratch. From concept to marketing, I grew Crobot to 700+ active members, earning recognition from Croatia's leading business platform Lider Media.",
    crobotDetail: "What started as a side project became Croatia's first custom AI chatbot — advanced conversational AI with community features and scalable architecture. I handled everything: development, design, marketing, and growth. The project's success led to a feature interview by Lider Media, Croatia's premier business publication.",
    crobotStat1: 'Members',
    crobotStat2: 'Croatian AI Chatbot',
    crobotStat3: 'Solo Built',
    // Press
    pressOverline: 'Press Recognition',
    pressTitle1: 'Featured in Global Platforms &',
    pressTitle2: 'Croatian Premier Business Media',
    pressDesc: "Recognized by Lider Media — Croatia's leading business platform — for AI-powered business solutions and web development, and by Elementor (elementor.com) for performance optimization work.",
    pressArticle1Title: "Who's Behind CroBot — Croatia's New AI Chatbot",
    pressArticle1Desc: 'Featured for developing CroBot, an AI-powered chatbot built for Croatian businesses, showcasing conversational AI and natural language processing.',
    pressArticle2Title: "Morning Chat with Crobot, Croatia's First AI Platform",
    pressArticle2Desc: "An exclusive interview detailing the development, capabilities, and future of Crobot, Croatia's pioneering AI platform.",
    pressArticle3Title: 'Image Optimizer Case Study',
    pressArticle3Desc: 'Recognized by Elementor for strong speed optimization results, demonstrating solid performance techniques in modern web development.',
    // Contact
    contactOverline: 'Get in touch',
    contactTitle1: 'Have a project',
    contactTitle2: 'in mind?',
    contactSubtitle: "I'd love to hear about it. Let's discuss how we can work together to bring your vision to life.",
    contactEmail: 'Email',
    contactPhone: 'Phone',
    contactWhatsApp: 'WhatsApp',
    contactWhatsAppCTA: "Let's talk on WhatsApp now!",
    contactAvailable: 'Available for new projects',
    contactFooterLocation: 'Designed & developed in Zagreb, Croatia',
    // Contact Widget
    widgetCTA: "Let's Talk",
    widgetTitle1: "Let's build",
    widgetTitle2: 'something great.',
    widgetDesc: "Whether you need a new website, an e-commerce platform, or a custom web solution — I'm here to help bring your vision to life.",
    widgetBased: 'Based in Zagreb, Croatia',
    // Preloader
    preloaderWord1: 'Smooth',
    preloaderWord2: 'Operator',
    preloaderTagline: 'Digital products with craft'
  },
  hr: {
    // Hero
    heroOverline: 'Portfolio',
    heroTitle1: 'Razvijam digitalne',
    heroTitle2: 'proizvode s pažnjom.',
    heroSubtitle: 'Developer fokusiran na vizualno dojmljiva i brza web iskustva, s izuzetnom pažnjom na svaki detalj.',
    heroStat1Value: '15+',
    heroStat1Label: 'Projekata isporučeno u 2025.',
    heroStat2Value: '6+',
    heroStat2Label: 'Godina iskustva',
    heroStat3Value: '8',
    heroStat3Label: 'Usluga u ponudi',
    heroScroll: 'Skrolaj za više',
    // Marquee
    marqueeText: 'Dizajn · Razvoj · Objava · ',
    // Projects
    projectsOverline: 'Odabrani radovi',
    projectsTitle: 'Nedavni projekti',
    projectsTotal: 'ukupno nedavnih projekata',
    projectsViewAll: 'Pogledaj svih',
    projectsProjects: 'projekata',
    projectsAllProjects: 'Svi projekti',
    // Project Descriptions
    projDescSocialamour: 'Premium prezentacija agencije za društvene mreže koja pokreće tim za holivudske zvijezde poput Selme Hayek, Lukea Evansa i svjetske brendove — oštro, moderno predstavljanje usluga.',
    projDescHmd: 'Ekskluzivna prezentacija londonskog arhitektonskog studija s prepoznatljivim vizualnim identitetom, glatkim mikro-interakcijama i besprijekornim minimalističkim dizajnom.',
    projDescAbc: 'Renomirana hrvatska tvrtka za dizajn interijera specijalizirana za premium kuhinje i poslovne prostore, s naprednom eCommerce platformom, kuriranim katalogom proizvoda i vizualno vođenim iskustvom pregledavanja.',
    projDescAnic: 'Korporativno remek-djelo s interaktivnom kartom koja prikazuje 400+ geo-lociranih lokacija, naprednom pretragom po vidljivom području, prilagođenom vizualizacijom podataka i besprijekornom integracijom pregleda tvrtke.',
    projDescWarans: 'Elegantna galerija likovne umjetnosti sa sigurnom kupnjom i prilagođenim My Account sučeljem koje prikazuje grafove rasta vrijednosti umjetnina — potpuno prilagođeni WooCommerce razvoj.',
    projDescPatela: 'Web stranica medicinske klinike s profesionalnom estetikom i korisničkim iskustvom usmjerenim na pacijente.',
    projDescGromela: 'Web stranica poslovnog centra s čistim rasporedom i sveobuhvatnim pregledom usluga.',
    projDescTerranook: 'Brend stranica inspirirana prirodom s toplom estetikom i dojmljivim pripovijedanjem.',
    projDescMagicpulse: 'eCommerce za dodatke prehrani s atraktivnim prikazom proizvoda i glatkim procesom kupnje.',
    projDescRoyal: 'Premium beauty eCommerce s fluidnim animacijama i besprijekornim iskustvom kupnje.',
    projDescWalllab: 'Trgovina zidnih dekoracija s vizualnim konfiguratorom proizvoda i modernim sučeljem.',
    projDescJoka: 'Modni eCommerce koji prati jedinstvenu retro viziju vlasnice — stilski prikaz odjeće s vintage-modernom fuzijom i ugodnim iskustvom kupnje.',
    projDescZalagaonice: 'Tržište zalagaonica s pretragom i detaljnim oglasima.',
    projDescSwanky: 'Najpopularniji moderni hostel u Zagrebu s poznatim barom i restoranom — booking platforma s živopisnim dizajnom, dostupnošću u stvarnom vremenu i najboljom društvenom atmosferom u gradu.',
    projDescZlatnirat: 'Premium hotel na uvali Zlatni Rat s pojednostavljenim procesom rezervacije i elegantnom prezentacijom iskustva gostiju.',
    projDescValmik: 'Premium platforma za najam luksuznih automobila s dostupnošću flote u stvarnom vremenu, prikazom vozila visoke klase i jednostavnim procesom rezervacije.',
    projDescFeluro: 'Usluga najma brodova s vizualnim prikazom flote i jednostavnim sustavom rezervacija.',
    projDescSpeedboat: 'Ture i najam glisera s avanturističkim dizajnom i brzom rezervacijom.',
    // Categories
    catAll: 'Sve',
    catBrandIdentity: 'Brend identitet',
    catEcommerce: 'eCommerce',
    catBooking: 'Rezervacije',
    catRentCar: 'Rent a Car',
    catRentBoat: 'Rent a Boat',
    catCustom: 'Custom-Special',
    // About
    aboutOverline: 'O meni',
    aboutTitle: 'Detalji su bitni.',
    aboutP1: 'Vjerujem da najbolji digitalni proizvodi nastaju iz opsesivne pažnje na detalje — i u izgledu i u funkcionalnosti. Svaki projekt prilika je za stvoriti nešto promišljeno i s namjerom.',
    aboutP2: 'S više od šest godina iskustva u isporuci digitalnih proizvoda, donosim duboko razumijevanje modernih web tehnologija i nepokolebljiv fokus na kvalitetu izrade.',
    aboutP3: 'Radio sam kao voditelj tima u agencijskom okruženju, a također vodim i vlastite projekte od početka do kraja — od dizajna do razvoja i puštanja u produkciju.',
    servicesOverline: 'Usluge',
    svcWebDev: 'Web razvoj',
    svcEcommerce: 'eCommerce rješenja',
    svcAI: 'AI integracije',
    svcMonthly: 'Mjesečno održavanje web stranica',
    svcDomain: 'Upravljanje domenom i hostingom',
    svcEmail: 'Email postavljanje',
    svcPerformance: 'Optimizacija brzine',
    svcSEO: 'SEO',
    // Education & Experience
    educationLabel: 'Obrazovanje',
    experienceLabel: 'Iskustvo',
    educationDegree: 'Prvostupnik',
    expRole1: 'Voditelj razvojnog tima',
    expType1: 'Prethodno iskustvo',
    expDesc1: 'Vodio web projekte u marketinškoj agenciji, isporučivao prilagođena rješenja i upravljao kompletnom infrastrukturom uz mentoriranje dizajnerskog i junior tima.',
    expRole2: 'Front End Developer',
    expType2: 'Prethodno iskustvo',
    expDesc2: 'Izrada brzih, piksel-savršenih sučelja na raznim klijentskim projektima.',
    expRole3: 'Osnivač — Osobni projekti',
    expType3: 'U tijeku',
    expDesc3: 'Osmišljavanje, izgradnja i rast proizvoda od nule — uključujući Crobot.ai.',
    // Crobot
    crobotOverline: 'Osobni projekt · Osnivač',
    crobotTitle: 'Osobni projekt — Crobot.ai',
    crobotDesc: 'Projekt iz strasti — prva hrvatska AI chatbot platforma, izgrađena potpuno od nule. Od ideje do marketinga, Crobot je narastao na 700+ aktivnih članova i zaslužio priznanje od Lider Medije, vodeće hrvatske poslovne platforme.',
    crobotDetail: 'Ono što je krenulo kao sporedni projekt preraslo je u prvog hrvatskog AI chatbota — napredna konverzacijska AI sa zajednicom i skalabilnom arhitekturom. Sve sam radio sam: razvoj, dizajn, marketing i rast. Uspjeh projekta rezultirao je intervjuom u Lider Mediji, vodećoj poslovnoj publikaciji u Hrvatskoj.',
    crobotStat1: 'Članova',
    crobotStat2: 'Hrvatski AI chatbot',
    crobotStat3: 'Samostalno izgrađen',
    // Press
    pressOverline: 'Medijsko priznanje',
    pressTitle1: 'Predstavljen na globalnim platformama i',
    pressTitle2: 'vodećim hrvatskim poslovnim medijima',
    pressDesc: 'Prepoznat od Lider Medije — vodeće hrvatske poslovne platforme — za AI rješenja i web razvoj, te od Elementora za optimizaciju performansi.',
    pressArticle1Title: 'Tko stoji iza CroBota — novog hrvatskog AI chatbota',
    pressArticle1Desc: 'Predstavljen za razvoj CroBota, AI chatbot rješenja za hrvatske tvrtke, s naglaskom na konverzacijsku AI i obradu prirodnog jezika.',
    pressArticle2Title: 'Jutarnji razgovor s Crobotom, prvom hrvatskom AI platformom',
    pressArticle2Desc: 'Ekskluzivni intervju o razvoju, mogućnostima i budućnosti Crobota — pionirske hrvatske AI platforme.',
    pressArticle3Title: 'Studija slučaja — optimizacija slika',
    pressArticle3Desc: 'Prepoznat od Elementora za izvrsne rezultate optimizacije brzine, demonstrirajući napredne tehnike u modernom web razvoju.',
    // Contact
    contactOverline: 'Kontakt',
    contactTitle1: 'Imate projekt',
    contactTitle2: 'na umu?',
    contactSubtitle: 'Rado bih čuo više o tome. Javite se i dogovorimo kako zajedno možemo ostvariti vašu viziju.',
    contactEmail: 'Email',
    contactPhone: 'Telefon',
    contactWhatsApp: 'WhatsApp',
    contactWhatsAppCTA: 'Javite se na WhatsApp!',
    contactAvailable: 'Dostupan za nove projekte',
    contactFooterLocation: 'Dizajnirano i razvijeno u Zagrebu, Hrvatska',
    // Contact Widget
    widgetCTA: 'Kontakt',
    widgetTitle1: 'Započnimo projekt',
    widgetTitle2: 'danas!',
    widgetDesc: 'Trebate novu web stranicu, eCommerce platformu ili prilagođeno rješenje — tu sam da pomognem ostvariti vašu viziju.',
    widgetBased: 'Zagreb, Hrvatska',
    // Preloader
    preloaderWord1: 'Smooth',
    preloaderWord2: 'Operator',
    preloaderTagline: 'Digitalni proizvodi s pažnjom'
  }
} as const;
export type Translations = (typeof translations)['en'];
interface LanguageContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: Translations;
}
const LanguageContext = createContext<LanguageContextType>({
  lang: 'en',
  setLang: () => {},
  t: translations.en
});
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLang] = useState<Lang>('en');
  const t = translations[lang];
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-381">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  return useContext(LanguageContext);
}